

/* eslint-disable */
import React, { memo, useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import { Grid } from '@material-ui/core'
import { Controller } from 'react-hook-form'

import * as Style from './styles'
import RegisterInput from 'components/RegisterInput'
import { useTranslation } from 'react-i18next'
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { Asterisk, Attach } from '../../../../assets/icons_svg'

function Documents({ errors, control, clearErrors, setError, setValue, UploadImage }) {
    const { t } = useTranslation()
    const [themeColor, setThemeColor] = useState(GetThemeColorFromStorage())
    const fileInputRef = useRef(null)

    const MAX_FILE_SIZE_MB = 2

    return (
        <Style.Container container item xs={12} spacing={2} alignItems="flex-start">
            <Style.CustomTitle>
                <b>{t('Documento')}</b>
            </Style.CustomTitle>

            <Grid
                item
                container
                xs={12}
                md={6}
                alignItems="center"
                style={{ marginTop: '-2.5px' }}
            >

                <Controller
                    name="emancipatedFile"
                    control={control}
                    render={({ value }) => (
                        <>
                            <RegisterInput
                                label="Anexar documento*"
                                xs={12}
                                value={value?.name || ''}
                                inputProps={{ readOnly: true }}
                                error={!!errors?.emancipatedFile}
                                helperText={t(errors?.emancipatedFile?.message)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                disableRipple
                                                aria-label="upload file"
                                                onClick={() => fileInputRef.current?.click()}
                                            >
                                                <Attach
                                                    sx={{
                                                        color: themeColor?.visual?.icons?.color,
                                                        fontSize: '20px',
                                                    }}
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            {/* Hidden file input */}
                            <input
                                type="file"
                                accept=".jpg,.png,.pdf"
                                style={{ display: 'none' }}
                                ref={fileInputRef}
                                onChange={(e) => {
                                    const file = e.target.files?.[0]

                                    if (!file) return

                                    const fileExtension = file.name.split('.').pop().toLowerCase()
                                    const isValidSize = file.size <= MAX_FILE_SIZE_MB * 1024 * 1024

                                    if (!['jpg', 'png', 'pdf'].includes(fileExtension)) {
                                        setError('emancipatedFile', {
                                            type: 'manual',
                                            message: t('O arquivo deve ser uma imagem em .jpg, .png ou .PDF.'),
                                        })

                                        return
                                    }


                                    if (!isValidSize) {
                                        setError('emancipatedFile', {
                                            type: 'manual',
                                            message: t('O arquivo deve ter no máximo 2 MB.'),
                                        })

                                        return
                                    }

                                    clearErrors('emancipatedFile')
                                    UploadImage(file)
                                }}
                            />
                        </>
                    )}
                />

                <Style.CustomAlert>
                    <Asterisk style={{ color: themeColor?.visual?.icons?.color }} />
                    <Grid
                        item
                        xs={11}
                        style={{
                            fontSize: '0.8rem',
                            paddingLeft: '0.5rem',
                            color: themeColor?.titles?.highlight?.textColor,
                        }}
                    >
                        {t('Anexar documento de emancipação. Serão aceitos imagens em .jpg, .png ou .PDF com até 2 MB.')}
                    </Grid>
                </Style.CustomAlert>
            </Grid>
        </Style.Container>
    )
}

export default memo(Documents)

